exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-415237b2&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/UniversityManage/EquipmentManage/EquipmentList/EquipmentBox/EquipmentBox.vue
// module id = 506
// module chunks = 0